module.exports = __webpack_public_path__ + "img/chat-gpt-integration-cover.02c20754.jpeg";